import request from "./ConfigRequest";

export const pageDisplayMessageDto = (index, size)=>{
    return request({
        url: 'displayMessage/pageDisplayMessageDto',
        params: {
            index,
            size,
        },
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
    });
};


export const saveDisplayMessage = (displayMessageDto)=>{
    return request({
        url: 'displayMessage/saveDisplayMessageDto',
        method: 'post',
        data: displayMessageDto,
        headers: {
            'Content-Type': 'application/json',
        },
    });
};


export const updateDisplayMessageDto = (displayMessageDto)=>{
    return request({
        url: 'displayMessage/updateDisplayMessageDto',
        method: 'put',
        data: displayMessageDto,
        headers: {
            'Content-Type': 'application/json',
        },
    });
};


export const searchDisplayMessageDto = (index, size, id)=>{
    return request({
        url: 'displayMessage/pageDisplayMessageDto',
        params: {
            index,
            size,
            id,
        },
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
    });
};
